<template>
  <v-footer color="white" app inset :height="$vuetify.breakpoint.smAndDown ? 64 : 32" style="min-height: auto!important;" v-if="!hideFooter">
    <v-container class="pa-0 ma-1">
      <v-layout row wrap justify-space-between>
        <v-flex xs12 sm4 class="text-xs-center" >
          <a v-if="!hidePolicy"
            href="#"
            @click.prevent="$store.dispatch('contracts/openContractDialog', {
              contractName: 'privacy_policy',
              justForInfo: true
            })">
            {{$tf('PrivacyPolicy')}}
          </a>
        </v-flex>
        <v-flex xs12 :sm4="!hideTerms||!hidePolicy" class="text-xs-center text-md-left">
          <p class="grey--text" style="text-align: center;margin-bottom: 1px">{{$tf('CopyrightNotice', {year: new Date().getFullYear()})}}</p></v-flex>
        <v-flex xs12 sm4 class="text-xs-center terms_container" >
          <a v-if="!hideTerms"
            href="#"
            @click.prevent="$store.dispatch('contracts/openContractDialog', {
              contractName: 'terms_and_conditions',
              justForInfo: true
            })">
            {{$tf('Terms and Conditions')}}
          </a>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'idonia-footer',
    props: {
      hidePolicy: {
        type: Boolean,
        default: false
      },
      hideTerms: {
        type: Boolean,
        default: false
      },
      hideFooter: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  footer {
    position: static !important;
    max-height: 64px;
  }
  .container {
    width: 100% !important;
    max-width: initial !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/IdoniaEmbedFooter.vue